import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { saveReadme } from '~map-preview/api/saveReadme'
import { useMapId } from '~map-preview/states/map'

function useSaveReadme() {
  const mapId = useMapId()
  const query = useQueryClient()

  const mutation = useMutation({
    mutationFn: saveReadme,
    onSuccess: () => {
      query.invalidateQueries({
        queryKey: ['getMapById', mapId]
      })
    }
  })

  return mutation as UseMutationResult<unknown>
}

export { useSaveReadme }
